/* eslint-disable react/prop-types */
import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import HTMLReactParser from 'html-react-parser';
// helpers
import { formatDate, getNameFromArray } from '../helpers';
// mui
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const currencies = {
  '1': '₴',
  '2': '$',
  '3': '€',
};

const months = [
  { 'id': 1, 'name': 'Січень' },
  { 'id': 2, 'name': 'Лютий' },
  { 'id': 3, 'name': 'Березень' },
  { 'id': 4, 'name': 'Квітень' },
  { 'id': 5, 'name': 'Травень' },
  { 'id': 6, 'name': 'Червень' },
  { 'id': 7, 'name': 'Липень' },
  { 'id': 8, 'name': 'Серпень' },
  { 'id': 9, 'name': 'Вересень' },
  { 'id': 10, 'name': 'Жовтень' },
  { 'id': 11, 'name': 'Листопад' },
  { 'id': 12, 'name': 'Грудень' },
];

const calculateAge = birthday => {
  const birthDate = new Date(birthday);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

const CVCard = ({ cvDetails }) => {
  const { t } = useTranslation('global');

  const [showDescr, setShowDescr] = useState(false);

  const {
    id,
    city,
    gender,
    birthday,
    modified,
    position,
    experience,
    salary_max,
    salary_min,
    profile_image,
    is_open_contact,
    salary_currency,
    general_experience,
  } = cvDetails;

  const toggleShowDescr = e => {
    e.stopPropagation();
    e.preventDefault();
    setShowDescr(!showDescr);
  };

  return (
    <Link to={`/candidates/listing/${id}`} target='_blank'>
      <div className='cvCard' style={{ opacity: is_open_contact ? 0.6 : 1 }}>
        <div className='mainInfoBlock'>
          <div>
            <h2>
              {position}
            </h2>
            <div className='genderAgeRegionBox'>
              {
                gender !== null
                  ? (
                    <p>
                      <FiberManualRecordIcon sx={{ mr: '8px', width: '10px', height: '10px', color: '#FF0B0F' }} />
                      {gender === 1 ? t('cvCard.male') : t('cvCard.female')}
                    </p>
                  )
                  : ''
              }
              {
                birthday
                  ? (
                    <p>
                      <FiberManualRecordIcon sx={{ mr: '8px', width: '10px', height: '10px', color: '#FF0B0F' }} />
                      {t('cvCard.age')} - {calculateAge(birthday)}
                    </p>
                  )
                  : ''
              }
              {
                city
                  ? (
                    <p>
                      <FiberManualRecordIcon sx={{ mr: '8px', width: '10px', height: '10px', color: '#FF0B0F' }} />
                      {`${city?.city_name}${city?.region_name !== null ? `, ${city?.region_name}`: ''}`}
                    </p>
                  )
                  : ''
              }
            </div>
            <h3>
              {
                salary_max || salary_min
                  ? (
                    <>
                      {salary_min ? parseInt(salary_min).toLocaleString('uk-UA') : ''}
                      {salary_min && salary_max ? ' - ' : ''}
                      {salary_max ? parseInt(salary_max).toLocaleString('uk-UA') : ''}
                      {' '}
                      {salary_currency && currencies[salary_currency]}
                      {salary_currency && `/${t('cvCard.month')}`}
                    </>
                  )
                  : t('cvCard.salaryNotSpecified')
              }
            </h3>
          </div>
          <img
            alt='profile image'
            className='profileImage'
            src={(profile_image && !profile_image.endsWith('/')) ? profile_image : '/Images/jobseekerSide/dummy-profile.png'}
          />
        </div>
        <div className='lastWorkPlace'>
          <h4>
            {t('cvCard.lastWorkPlace')}
          </h4>
          {
            experience
              ? (
                <>
                  <div className='lastWorkPlaceBox'>
                    {
                      experience?.company_name
                        ? (
                          <p>
                            <FiberManualRecordIcon sx={{ mr: '8px', width: '10px', height: '10px', color: '#FF0B0F' }} />
                            <span>{experience?.company_name}</span>
                          </p>
                        )
                        : ''
                    }
                    {
                      experience?.position_name
                        ? (
                          <p>
                            <FiberManualRecordIcon sx={{ mr: '8px', width: '10px', height: '10px', color: '#FF0B0F' }} />
                            {experience?.position_name}
                          </p>
                        )
                        : ''
                    }
                    {
                      experience?.from_month
                        ? (
                          <p>
                            <FiberManualRecordIcon sx={{ mr: '8px', width: '10px', height: '10px', color: '#FF0B0F' }} />
                            {getNameFromArray(experience?.from_month, months)}{' '}{experience?.from_year}
                            {experience?.to_month || experience?.still_working ? ' - ' : ''}
                            {
                              experience?.still_working
                                ? t('cvCard.stillWorking')
                                : experience?.to_month
                                  ? `${getNameFromArray(experience?.to_month, months)} ${experience?.to_year}`
                                  : ''
                            }
                          </p>
                        )
                        : ''
                    }
                  </div>
                  <button type='button' onClick={e => toggleShowDescr(e)}>
                    {
                      showDescr
                        ? <>{t('cvCard.showLess')}<i className='fa-solid fa-chevron-up' /></>
                        : <>{t('cvCard.showMore')}<i className='fa-solid fa-chevron-down' /></>
                    }
                  </button>
                  {
                    showDescr && experience?.description && (
                      <div className='standartListStyle'>
                        {HTMLReactParser(experience?.description)}
                      </div>
                    )
                  }
                </>
              )
              : t('cvCard.notSpecified')
          }
        </div>
        <div className='cvCardFooter'>
          <div className='experienceAge'>
            <p>
              {t('cvCard.experience')}{': '}
              {
                general_experience
                  ? `${general_experience} ${t('cvCard.years')}`
                  : parseInt(general_experience) < 1 && general_experience !== null
                    ? t('cvCard.lessOneYear')
                    : t('cvCard.notSpecified')
              }
            </p>
          </div>
          <div className='updatedDate'>
            <p>
              <i className='fa-solid fa-calendar-days' />
              {t('cvCard.updated')}{': '}
              {
                modified
                  ? formatDate(modified)
                  : t('cvCard.notSpecified')
              }
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CVCard;
